// import moment from 'moment'
class atributes {
  constructor(empId, atribId, value,atribName,id,name) {
    this.empId = empId;
    this.atribId = atribId;
    this.value = value;
    this.atribName = atribName
    this.id = id
    this.name=name
  }
  static fromJson({
    empId, atribId, valor, nombreAtrib,AtribId,Nombre }) {
    return new atributes(empId, atribId, valor, nombreAtrib,AtribId,Nombre);
  }
}
export default atributes;
